/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.swipers = {};

function actualizarVariantes(productId, inputName, infoPiedras, infoIndex) {

  var container = document.getElementById('fieldset-' + productId + '-' + infoIndex);
  if (!container) return;

  container.addEventListener('change', function(event) {
    if (event.target.type !== 'radio' || event.target.name !== inputName) return;

    var labels = container.querySelectorAll('.ce-color-variantes__item');

    labels.forEach(function(label) {
        label.classList.remove('ce-color-variantes__item--active');
    });

    var selectedLabel = container.querySelector('label[for="' + event.target.id + '"]');
    if (selectedLabel) selectedLabel.classList.add('ce-color-variantes__item--active');

    var datosVariante = infoPiedras.find(function(info) {
        return info.id == event.target.value;
    });

    //console.log('DATOS ', datosVariante);

    if (datosVariante) {
      var contenedor = document.querySelector('#product-' + productId + '-' + infoIndex);
      if (!contenedor) return;
    
      var linkElements = document.querySelectorAll('a#link-' + productId + '-' + infoIndex);
      linkElements.forEach(function(element) {
        element.href = datosVariante.url;
      });
    
      var titleElement = contenedor.querySelector('#title-' + productId + '-' + infoIndex + ' a');
      if (titleElement) titleElement.textContent = datosVariante.title;
    
      var subtitleElement = contenedor.querySelector('p#subtitle-' + productId + '-' + infoIndex);
      if (subtitleElement) subtitleElement.innerHTML = datosVariante.feature;

      var contenedorPrice = contenedor.querySelector('.ProductItem__PriceList');
      
      var precioFormateado = (Number(datosVariante.price) / 100).toFixed(2) + ' €';
      var precioElements = document.querySelectorAll('#price-' + productId + '-' + infoIndex);
      precioElements.forEach(function(element) {
        element.textContent = precioFormateado;
      });

      var comparePriceFormateado = (Number(datosVariante.compare_at_price) / 100).toFixed(2) + ' €';
      var comparePriceElements = contenedor.querySelectorAll('#compare-at-price-' + productId + '-' + infoIndex);
      
      if (comparePriceElements.length === 0 && datosVariante.compare_at_price > datosVariante.price) {
        var comparePriceElement = document.createElement('span');
        comparePriceElement.id = 'compare-at-price-' + productId + '-' + infoIndex;
        comparePriceElement.className = 'ProductItem__Price Price Price--compareAt Text--subdued ce-pc__price';
        comparePriceElement.textContent = comparePriceFormateado;
        contenedorPrice.appendChild(comparePriceElement);
        comparePriceElements = [comparePriceElement];
      }
      
      // Actualizar todos los elementos en el array
      comparePriceElements.forEach(function(element) {
        if (datosVariante.compare_at_price > datosVariante.price) {
          element.textContent = comparePriceFormateado;
          element.style.display = '';
          precioElements.forEach(function(priceElement) {
            priceElement.style.color = 'var(--product-sale-price-color)';
          });
        } else {
          element.textContent = '';
          element.style.display = 'none';
          precioElements.forEach(function(priceElement) {
            priceElement.style.color = 'black';
          });
        }
      });
      
      actualizarSwiper(productId, infoIndex, datosVariante);
    }

  });

}


function actualizarSwiper(productId, infoIndex, datosVariante) {
  var carousel = document.querySelector('#carousel-' + productId + '-' + infoIndex);
  if (!carousel) return;

  var swiperInstance = window.swipers[productId];
  if (!swiperInstance) {
    swiperInstance = new Swiper(carousel, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
    window.swipers[productId] = swiperInstance;
  }

  actualizarSwiperConNuevasImagenes(swiperInstance, datosVariante.media, function() {
    if (swiperInstance.slides.length >= 2) {
      swiperInstance.params.loop = true;
      swiperInstance.update();
    }
  });

}

function actualizarSwiperConNuevasImagenes(swiperInstance, nuevasImagenes, callback) {

  var carousel = swiperInstance.el;
  var loader = carousel.nextElementSibling;
  if (loader) loader.style.display = 'block';

  var navigationElements = swiperInstance.el.querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination');
  navigationElements.forEach(function(elem) { elem.style.display = 'none'; });

  swiperInstance.removeAllSlides();
  var imagesLoaded = 0;

  nuevasImagenes.forEach(function(imagen) {
    var img = new Image();
    img.onload = function() {
      imagesLoaded++;
      if (imagesLoaded === nuevasImagenes.length) {
        if (loader) loader.style.display = 'none';
        navigationElements.forEach(function(elem) { elem.style.display = 'block'; });
        if (callback) callback();
      }
    };
    img.src = imagen.src;
    var slideContent = '<div class="swiper-slide"><img src="' + img.src + '" class="ProductItem__Image Image--lazyLoad"></div>';
    swiperInstance.appendSlide(slideContent);
  });

  swiperInstance.update();
}


document.addEventListener('DOMContentLoaded', function() {

  document.querySelectorAll('.ProductItem.ce-product__item').forEach(function(elemento) {
    var mainProductId = elemento.getAttribute('data-product-id');
    var mainIndex = elemento.getAttribute('data-index');

    if (!window.swipers[mainProductId]) {
      var carousel = document.querySelector('#carousel-' + mainProductId + '-' + mainIndex);
      window.swipers[mainProductId] = new Swiper(carousel, {
        direction: 'horizontal',
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

  });

  document.querySelectorAll('.ce-variantes-piedras__input').forEach(function(elemento) {
    var productId = elemento.getAttribute('data-product-id');
    var inputName = elemento.getAttribute('data-input-name');

    var contenedorDiv = elemento.closest('div[id^="fieldset-"]');
    if (contenedorDiv) {
      var infoPiedrasStr = contenedorDiv.getAttribute('data-info-piedras');
      var infoPiedras = JSON.parse(infoPiedrasStr);
      var infoIndex = contenedorDiv.getAttribute('data-index');
    }

    actualizarVariantes(productId, inputName, infoPiedras, infoIndex);
  });

});

